<script>
import moment from "moment";
import axios from '@/utils/axios';
import "daterangepicker/daterangepicker.js";
import "daterangepicker/daterangepicker.css";
import DateRangePicker from "daterangepicker";

export default {
  inject: ['setLoading'],
  data() {
    return {
      activity_logs: [],
      login_history: [],
      pagination: {
        current_page: 1,
        per_page: 100,
        last_page: 1,
        total: 0,
        links: []
      },
      activity_filter: {  // For Activity Log
        action: '',
        action_on: null,
        from_date: moment().subtract(30, "days").format("YYYY-MM-DD"),
        to_date: moment().format("YYYY-MM-DD"),
      },
      login_filter: {     // For Login History
        from_date: moment().subtract(30, "days").format("YYYY-MM-DD"),
        to_date: moment().format("YYYY-MM-DD"),
      },
      modules: [],
      type: '',
      activityDatePicker: null,
      loginDatePicker: null,
    };
  },

  mounted() {},

  computed: {
    serialNo() {
      return (this.pagination.current_page - 1) * this.pagination.per_page;
    },
  },

  methods: {
    initActivityDatePicker() {
      const start = moment().subtract(30, "days");
      const end = moment();
      
      if (this.activityDatePicker) {
        this.activityDatePicker.remove();
      }

      this.activityDatePicker = new DateRangePicker(
        this.$refs.activityDateRangeInput,
        {
          startDate: start,
          endDate: end,
          locale: {
            format: "DD/MM/YYYY",
            separator: " - "
          },
          ranges: {
            Today: [moment(), moment()],
            Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
            "Last 7 Days": [moment().subtract(6, "days"), moment()],
            "Last 30 Days": [moment().subtract(29, "days"), moment()],
            "This Month": [moment().startOf("month"), moment().endOf("month")],
            "Last Month": [
              moment().subtract(1, "month").startOf("month"),
              moment().subtract(1, "month").endOf("month"),
            ],
          }
        },
        (start, end) => {
          this.setActivityDateRange(start, end);
        }
      );
      
      this.setActivityDateRange(start, end);
    },

    initLoginDatePicker() {
      const start = moment().subtract(30, "days");
      const end = moment();
      
      if(this.loginDatePicker){
        this.loginDatePicker.remove();
      }

      this.loginDatePicker = new DateRangePicker(
        this.$refs.loginDateRangeInput,
        {
          startDate: start,
          endDate: end,
          locale: {
            format: "DD/MM/YYYY",
            separator: " - "
          },
          ranges: {
            Today: [moment(), moment()],
            Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
            "Last 7 Days": [moment().subtract(6, "days"), moment()],
            "Last 30 Days": [moment().subtract(29, "days"), moment()],
            "This Month": [moment().startOf("month"), moment().endOf("month")],
            "Last Month": [
              moment().subtract(1, "month").startOf("month"),
              moment().subtract(1, "month").endOf("month"),
            ],
          }
        },
        (start, end) => {
          this.setLoginDateRange(start, end);
        }
      );
      
      this.setLoginDateRange(start, end);
    },

    setActivityDateRange(start, end) {
      this.activity_filter.from_date = start.format("YYYY-MM-DD");
      this.activity_filter.to_date = end.format("YYYY-MM-DD");
    },

    setLoginDateRange(start, end) {
      this.login_filter.from_date = start.format("YYYY-MM-DD");
      this.login_filter.to_date = end.format("YYYY-MM-DD");
    },

    async loadModules(){
     try{
      const response = await axios.get(`/modules`);
      this.modules = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     } 
    },

    async activityLogs(page = 1) {
      this.type = 'activity'; 
      this.loadModules(); 
      this.setLoading(true);
      try {
        const params = {
          page,
          per_page: this.pagination.per_page,
          action: this.activity_filter.action || '',
          action_on: this.activity_filter.action_on || '',
          from_date: this.activity_filter.from_date || '',
          to_date: this.activity_filter.to_date || ''
        };
        const query_string = new URLSearchParams(params).toString();
        const response = await axios.get(`/users/activity-log?${query_string}`);
        this.activity_logs = response.data.data.data;
        this.pagination = {
          current_page: response.data.data.current_page,
          per_page: response.data.data.per_page,
          last_page: response.data.data.last_page,
          total: response.data.data.total,
          links: response.data.data.links  
        };
      } catch(error) {
        this.$swalToast(error.message, 'error');
      } finally {
        this.setLoading(false);
      } 
    },

    changePage(url){
     if(!url) return;
     const page = new URL(url).searchParams.get("page");
     if(this.type === 'activity'){
      this.activityLogs(page);
     }else{
      this.loginHistory(page);
     }
    },

    async loginHistory(page = 1){
     this.type = 'history'; 
     this.setLoading(true);
     try{
      const params = {
        page,
        user_id: this.auth?.id,
        per_page: this.pagination.per_page,
        from_date: this.login_filter.from_date || '',
        to_date: this.login_filter.to_date || ''
      };
      const query_string = new URLSearchParams(params).toString();
      const response = await axios.get(`/users/logged-history?${query_string}`);
      this.login_history = response.data.data.data;
      this.pagination = {
        current_page: response.data.data.current_page,
        per_page: response.data.data.per_page,
        last_page: response.data.data.last_page,
        total: response.data.data.total,
        links: response.data.data.links  
      };
      }catch(error){
       this.$swalToast(error.message, 'error');
      }finally{
       this.setLoading(false);
      } 
    },

    clearFilter(){
     this.activity_filter = { action: '', action_on: null, from_date: '', to_date: '' };
     this.login_filter = { from_date: '', to_date: '' };
    }
  },
};
</script>


<template>

<!-- ACTIVITY LOG -->
<div class="modal" id="activityLogModal">
 <div class="modal-dialog modal-dialog-scrollable modal-lg">
   <div class="modal-content">

    <div class="modal-header">
      <h4 class="modal-title">Activiy Log</h4>
      <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
    </div>

    <div class="modal-body">

    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3 mb-2">
    <div class="me-1" v-if="activity_filter.action || activity_filter.action_on || activity_filter.from_date">
   <a href="javascript:void(0);" class="text-danger" @click="clearFilter()">
    <i class="ti ti-filter-x"></i>
   </a>
  </div> 

  <div class="me-3">
   <div class="input-icon-end position-relative">
    <input type="text" class="form-control date-range bookingrange" ref="activityDateRangeInput" placeholder="dd/mm/yyyy - dd/mm/yyyy">
    <span class="input-icon-addon"><i class="ti ti-chevron-down"></i></span>
   </div>
  </div>

  <div class="me-3 custom-vueselect">
   <vue-select v-model="activity_filter.action_on" label="name" :options="modules" :reduce="module => module.name" placeholder="Action On" />
  </div>

  <div class="me-3">
    <select class="form-control" v-model="activity_filter.action">
      <option value="">Action</option> 
      <option value="create">Create</option>
      <option value="update">Update</option>
      <option value="delete">Delete</option>
    </select>
  </div>

  <div class="">
   <button type="button" class="btn btn-dark" @click="activityLogs()"><i class="ti ti-search"></i></button>
  </div>
  </div>
    

      <div class="custom-datatable-filter table-responsive mt-2" v-if="activity_logs?.length">
      <table class="table table-responsive datatable thead-light">
      <thead>
        <tr>
          <th>#</th>
          <th>Action</th>
          <th>Action By</th>
          <th>Action On</th>
          <th>Action Title</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in activity_logs" :key="row.id">
          <td>{{ serialNo + index + 1 }}.</td>  
          <td>{{ row.action }}</td>
          <td><img :src="$profileImage(row.action_by.image, clientAdmin)" width="22" /> {{ row.action_by.name }}</td>
          <td>{{ row.action_on }}</td>
          <td>{{ row.action_title }}</td>
          <td>{{ $formatDate(row.created_at, 'DD-MM-YY, hh:mm a') }}</td>
        </tr>
      </tbody>
      </table>
      </div> 
      </div>

      <div class="modal-footer">
         <!-- Pagination -->
       <nav v-if="pagination.links && pagination.links.length > 3" class="m-3">
        <ul class="pagination pagination-sm">
          <li v-for="(link, index) in pagination.links" :key="index"
            :class="['page-item', { active: link.active, disabled: !link.url }]">
            <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url)"></a>
          </li>
        </ul>
       </nav>
      </div>

    </div>
  </div>
</div>
<!-- ACTIVITY LOG -->

<!-- LOGIN HISTORY -->
<div class="modal" id="loginHistoryModal">
 <div class="modal-dialog modal-dialog-scrollable modal-lg">
   <div class="modal-content">

    <div class="modal-header">
      <h4 class="modal-title">Login History</h4>
      <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
    </div>

    <div class="modal-body">

   <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3 mb-2">
   <div class="me-1" v-if="login_filter.from_date || login_filter.to_date">
    <a href="javascript:void(0);" class="text-danger" @click="clearFilter()">
      <i class="ti ti-filter-x"></i>
    </a>
  </div> 

  <div class="me-3">
   <div class="input-icon-end position-relative">
    <input type="text" class="form-control date-range bookingrange" ref="loginDateRangeInput" placeholder="dd/mm/yyyy - dd/mm/yyyy">
    <span class="input-icon-addon"><i class="ti ti-chevron-down"></i></span>
   </div>
  </div>

  <div class="">
   <button type="button" class="btn btn-dark" @click="loginHistory()"> <i class="ti ti-search"></i> </button>
  </div>
  </div>
    

      <div class="custom-datatable-filter table-responsive mt-2" v-if="login_history?.length">
      <table class="table table-responsive datatable thead-light">
      <thead>
        <tr>
          <th>#</th>
          <th>User</th>
          <th>IP Address</th>
          <th>Login At</th>
          <th>Log Out</th>
          <th>Last Activity At</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in login_history" :key="row.id">
          <td>{{ serialNo + index + 1 }}.</td>  
          <td><img :src="$profileImage(row.user?.image, clientAdmin)" width="22" /> {{ row.user?.name }}</td>
          <td>{{ row.ip_address }}</td>
          <td>{{ $formatDate(row.login_at, 'DD-MM-YY, hh:mm a') }}</td>
          <td>{{ (row.logout_at) ? $formatDate(row.logout_at, 'DD-MM-YY hh:mm a') : '' }}</td>
          <td>{{ $formatDate(row.last_activity_at, 'DD-MM-YY, hh:mm a') }}</td>
        </tr>
      </tbody>
      </table>
      </div> 
      </div>

      <div class="modal-footer">
         <!-- Pagination -->
       <nav v-if="pagination.links && pagination.links.length > 3" class="m-3">
        <ul class="pagination pagination-sm">
          <li v-for="(link, index) in pagination.links" :key="index"
            :class="['page-item', { active: link.active, disabled: !link.url }]">
            <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url)"></a>
          </li>
        </ul>
       </nav>
      </div>

    </div>
  </div>
</div>
<!-- LOGIN HISTORY -->

</template>
